const moment = require('moment');
const defaultState = {
    finalList: [],
    loading: false,
    errors:{},
    finalListAlarms: [],
    loadingAlarms: false,
    errorsAlarms:{},
    finalListAll: [],
    lastFiltersAll:[],
    loadingAll: false,
    errorsAll:{},
    excelDataSet:[]
}
  
  export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_OPEN_LIST_FULFILLED': {
        return {
          ...state,
          finalList: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_OPEN_LIST_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_OPEN_LIST_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
      
      case 'FETCH_ALARMS_LIST_FULFILLED': {       
        return {
          ...state,
          finalListAlarms: action.payload.data,
          loadingAlarms: false,
          errorsAlarms: {}
        }
      }
  
      case 'FETCH_ALARMS_LIST_PENDING': {
        return {
          ...state,
          loadingAlarms: true,
          errorsAlarms: {}
        }
      }
  
      case 'FETCH_ALARMS_LIST_REJECTED': {
        return {
          ...state,
          loadingAlarms: false,
          errorsAlarms: { global: action.payload.message }
        }
      }

      case 'FETCH_ALL_LIST_FULFILLED': {      
        let arrayMain=[];
        let arrayMainExcel=[];
        let newItem = {};
        let auxArrayData = [];
        let auxNewDataItemLine = [];
        let auxID = {};
        let auxGroup = {};
        let auxBegin = {};
        let auxEnd = {};
        let auxMode = {};
        let auxType = {};
        let auxMinVal = {};
        let auxMaxVal = {};
        let auxComments = {};
        let auxTimeZone = 'Europe/Lisbon';//default
        let auxTech = 'none';
        let auxMarketHourBegin = '';
        let auxMarketHourEnd = '';
        let isCond = false;

        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
                newItem = {};
                newItem = element;//limpa para criar um novo. Criamos campos com hora convertida para mostrar em local time no  export de Excel
                newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                arrayMain.push(newItem);
                //excel data set
                auxTimeZone = element.TIMEZONE;
                auxMarketHourBegin = ' (H' + moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).add(2,'hour').format('H') + ')';
                auxMarketHourBegin = auxMarketHourBegin === ' (H0)' 
                    ? ' (H24)'
                    : (auxMarketHourBegin === ' (H1)' 
                        ? ' (H25)' 
                        : auxMarketHourBegin
                    );
                auxMarketHourEnd = ' (H' + moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).add(2,'hour').format('H') + ')';
                auxMarketHourEnd = auxMarketHourEnd === ' (H0)' 
                    ? ' (H24)'
                    : (auxMarketHourEnd === ' (H1)'
                        ? ' (H25)'
                        : auxMarketHourEnd
                    );
                if(auxTech !== element.TECHNOLOGY){
                    auxTech = element.TECHNOLOGY;
                    auxNewDataItemLine = [];
                    auxID = {};
                    auxID["value"] = element.TECHNOLOGY ;
                    auxID["style"] = {font: {sz: "15", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "FFFF0000"}}};
                    auxNewDataItemLine.push(auxID);
                    auxArrayData.push(auxNewDataItemLine);
                }
                isCond = element.MODE === 'COND';
                auxNewDataItemLine = [];
                auxID = {};
                auxID["value"] = element.ID.toString() ;
                auxID["style"] = {font: {bold: true}, fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxGroup = {};
                auxGroup["value"] = element.G_GROUP ;
                auxGroup["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxBegin = {};
                auxBegin["value"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm') + auxMarketHourBegin;
                auxBegin["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxEnd = {};
                auxEnd["value"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm') + auxMarketHourEnd;
                auxEnd["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxMode = {};
                auxMode["value"] = element.MODE ;
                auxMode["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxType = {};
                auxType["value"] = element.TYPE ;
                auxType["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxMinVal = {};
                auxMinVal["value"] = element.FLAGT_MINVAL.toString() ;
                auxMinVal["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxMaxVal = {};
                auxMaxVal["value"] = element.MAX_VAL.toString() ;
                auxMaxVal["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};
                auxComments = {};
                auxComments["value"] = element.COMMENTS ;
                auxComments["style"] = {fill: (isCond ? {patternType: "solid", fgColor: {rgb: "ffcd8e"}} : (index % 2 === 0 ? {patternType: "solid", fgColor: {rgb: "b6b7ba"}} : {patternType: "solid", fgColor: {rgb: "ffffff"}}))};

                auxNewDataItemLine.push(auxID);
                auxNewDataItemLine.push(auxGroup);
                auxNewDataItemLine.push(auxBegin);
                auxNewDataItemLine.push(auxEnd);
                auxNewDataItemLine.push(auxMode);
                auxNewDataItemLine.push(auxType);
                auxNewDataItemLine.push(auxMinVal);
                auxNewDataItemLine.push(auxMaxVal);
                auxNewDataItemLine.push(auxComments);
                auxArrayData.push(auxNewDataItemLine);
            });

            arrayMainExcel=[
                {
                    columns: [],
                    data: [
                        [
                            {value: "REPORT DIÁRIO INDISPS" , style: {font: {sz: "16", bold: true}}},
                        ]
                    ]
                },
                {
                    columns: [],
                    data: [
                        [
                            {value: "Parâmetros:"},
                            {value: state.lastFiltersAll.BEGIN_DATE},
                            {value: " até " + state.lastFiltersAll.END_DATE},
                        ]
                    ]
                },            
                {
                    columns: ["Código", "Cód.Grupo", "Início","Fim","Cond/Indisp","Tipo","TLR/ValMin","Val/ValMax","Observações"],
                    data: auxArrayData
                },
                {
                    columns: ["Legenda:"],
                    data: [
                        [
                            {value: "CD- Caudal:" , style: {font: {sz: "9", bold: true}}},
                            {value: "CJ- Cota Jusante" , style: {font: {sz: "9", bold: true}}},
                            {value: "CM- Cota Montante" , style: {font: {sz: "9", bold: true}}},
                            {value: "FT- Fortuita  PG- Programada" , style: {font: {sz: "9", bold: true}}},
                            {value: "PL- Plano Manutenção" , style: {font: {sz: "9", bold: true}}},
                            {value: "PT- Potência" , style: {font: {sz: "9", bold: true}}},
                            {value: "QD- Queda" , style: {font: {sz: "9", bold: true}}},
                            {value: "OT- Outro" , style: {font: {sz: "9", bold: true}}},
                            {value: moment().tz(auxTimeZone).format('YYYY-MM-DD HH:mm'), style: {font: {sz: "15"}}},
                        ]
                    ]
                },
            ];
        }else{
            console.log('FETCH_ALL_LIST_FULFILLED error: ');
            console.dir(action.payload.data);
        }
        return {
            ...state,
            finalListAll: arrayMain,
            loadingAll: false,
            errorsAll: {},
            excelDataSet: arrayMainExcel
        }
      }
  
      case 'FETCH_ALL_LIST_PENDING': {
        return {
          ...state,
          loadingAll: true,
          errorsAll: {}
        }
      }
  
      case 'FETCH_ALL_LIST_REJECTED': {
        return {
          ...state,
          loadingAll: false,
          errorsAll: { global: action.payload.message }
        }
      }

      case 'LASTFILTER_ALL': {
        return {
          ...state,
          lastFiltersAll: action.payload
        }
      }      

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/all-sheets-reducer.js